import React, { useState } from "react";

export const FAQ = (props) => {
    const [activeIndex, setActiveIndex] = useState(null);

    const toggleAccordion = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    return (
        <div id="faq" className="text-center">
            <div className="container">
                <div className="section-title">
                    <h2>FAQ</h2>
                    <p>
                        Clear answers designed to address your most common questions.
                    </p>
                    <div className="bar" />
                </div>
                <div className="row faq-row">
                    <div className="col-md-8 mt">
                        <div className="faq-container">
                            {props.data
                                ? props.data.map((d, i) => (
                                    <div key={`${d.question}-${i}`} className="faq-item">
                                        <div
                                            className={`faq-question ${activeIndex === i ? "active" : ""
                                                }`}
                                            onClick={() => toggleAccordion(i)}
                                        >
                                            <h4>{d.question}</h4>
                                            <i
                                                className={`fa-solid fa-plus`}
                                            ></i>
                                        </div>
                                        <div
                                            className={`faq-answer ${activeIndex === i ? "show" : ""
                                                }`}
                                        >
                                            <p>{d.answer}</p>
                                        </div>
                                    </div>
                                ))
                                : "loading"}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
